import { openDB } from "idb";

const DB_NAME = "21stIndexDb";
const STORE_NAME = "policyDoc";

const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          keyPath: "id",
          autoIncrement: true,
        });
      }
    },
  });
};

export const addFile = async (file, id = null) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");

  if (id === null) {
    // Add new file if no ID is provided
    await tx.store.add({ file });
  } else {
    // Update existing file if ID is provided
    await tx.store.put({ id, file });
  }

  await tx.done;
};

export const getFile = async (id) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readonly");
  const file = await tx.store.get(id);

  await tx.done;
  return file;
};

export const clearStore = async () => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  await tx.store.clear();
  await tx.done;
};

export const deleteById = async (id) => {
  const db = await initDB(); // Assuming initDB initializes and returns the IndexedDB instance
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.store;

  // Delete the record with the specified ID
  await store.delete(id);

  await tx.done;
};
